export default __webpack_public_path__ + "static/media/unchecked.9902141b.svg";